type Sound = 'pass' | 'plant' | 'swish' | 'rim' | 'horn' | 'block';

export class AudioRack {
  private context?: AudioContext;
  muted = false;

  setMuted(muted: boolean): void { this.muted = muted; }

  play(sound: Sound): void {
    if (this.muted) return;
    const context = this.context ??= new AudioContext();
    if (context.state === 'suspended') void context.resume();
    const now = context.currentTime;
    if (sound === 'pass') this.noise(context, now, .05, 650, .13);
    if (sound === 'plant') this.noise(context, now, .035, 180, .08);
    if (sound === 'swish') {
      this.noise(context, now, .16, 2600, .16);
      this.tone(context, now, 510, 740, .12, .08, 'sine');
    }
    if (sound === 'rim') {
      this.tone(context, now, 390, 240, .14, .14, 'triangle');
      this.tone(context, now + .045, 610, 360, .1, .08, 'square');
    }
    if (sound === 'block') this.noise(context, now, .07, 340, .18);
    if (sound === 'horn') {
      this.tone(context, now, 180, 170, .34, .1, 'sawtooth');
      this.tone(context, now + .04, 225, 215, .3, .07, 'square');
    }
  }

  private tone(context: AudioContext, start: number, from: number, to: number, duration: number, volume: number, type: OscillatorType): void {
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    oscillator.type = type;
    oscillator.frequency.setValueAtTime(from, start);
    oscillator.frequency.exponentialRampToValueAtTime(Math.max(1, to), start + duration);
    gain.gain.setValueAtTime(volume, start);
    gain.gain.exponentialRampToValueAtTime(.001, start + duration);
    oscillator.connect(gain).connect(context.destination);
    oscillator.start(start);
    oscillator.stop(start + duration);
  }

  private noise(context: AudioContext, start: number, duration: number, cutoff: number, volume: number): void {
    const length = Math.ceil(context.sampleRate * duration);
    const buffer = context.createBuffer(1, length, context.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < data.length; i += 1) data[i] = Math.sin(i * 12.9898) * Math.cos(i * .038) * (1 - i / data.length);
    const source = context.createBufferSource();
    const filter = context.createBiquadFilter();
    const gain = context.createGain();
    filter.type = 'lowpass';
    filter.frequency.value = cutoff;
    gain.gain.setValueAtTime(volume, start);
    gain.gain.exponentialRampToValueAtTime(.001, start + duration);
    source.buffer = buffer;
    source.connect(filter).connect(gain).connect(context.destination);
    source.start(start);
  }
}
